<template>
    <div class="slide">
        <TriviaCard :currentTrivia="currentTrivia" :title="questions.question.title"
                    :answers="questions.question.answers"
                    :correctAnswer="questions.question.correctAnswer"
                    :nextRoute="nextRoute"
                    :current="3"
                    :total="4" />
    </div>
</template>

<script>
import TriviaCard from '@/components/TriviaCard.vue'

export default {
    name: 'trivia',
    components: {
        TriviaCard,
    },
    data() {
        return {
            nextRoute: "trivia-10",
            currentTrivia: 9,
            questions: {
                question: {
                    "title": "The two most common reporting mistakes are:",
                    "answers": [
                        {"key": "A", "answer": "Inaccurate Information"},
                        {"key": "B", "answer": "Objectivity"},
                        {"key": "C", "answer": "Submitted Too Late"},
                        {"key": "D", "answer": "Too Much Information"}
                    ],
                    "correctAnswer": ["A", "C"]
                }
            }
        }
    },
  mounted() {
    window.setTimeout(() => {
          window.scrollTo(0,1)
        }, 1000)
  }
}
</script>

<style lang="scss" scoped>

</style>
